// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5b589a41","419":"c3149e42","500":"424c11f0","561":"7e0f42b2","563":"a08f5b1c","771":"084a638f","774":"d37e1f98","883":"335f602c","942":"ef878a34"}[chunkId] + ".chunk.js";
};